import { useState } from "react"
import { useAuth } from "../lib/auth-context"
import { Button, Card, CardBody, Input, Alert } from "../components/ui"

export function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await signIn(email, password)
    } catch {
      setError("فشل تسجيل الدخول. تحقق من البريد الإلكتروني وكلمة المرور.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-muted p-lg">
      <div className="w-full max-w-[384px]">
        <div className="mb-2xl flex flex-col items-center gap-sm text-center">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/logo-mark-trim.png" alt="عزبتنا" className="h-16 w-auto" />
          <p className="text-body-sm text-text-secondary">لوحة الإدارة</p>
        </div>

        <Card>
          <CardBody>
            <form onSubmit={handleSubmit} className="flex flex-col gap-lg">
              {error && (
                <Alert variant="danger" dismissible onDismiss={() => setError("")}>
                  {error}
                </Alert>
              )}

              <Input
                type="email"
                label="البريد الإلكتروني"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@ezbatna.com"
                autoComplete="username"
                required
              />
              <Input
                type="password"
                label="كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
              <Button type="submit" size="lg" loading={loading} className="w-full">
                تسجيل الدخول
              </Button>
            </form>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
